import React, { useEffect, useState } from "react";

// import WallDataService from "../services/wall.services";
import { storage, firestore, auth } from "../firebase";
import firebase from "firebase/compat/app";
import { snapshotEqual, update } from "firebase/firestore";
import { useParams, Link } from "react-router-dom";
import { useUserProvider } from "../context/UserProvider";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify"; // then this

import {
  collection,
  getDocs,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

// Conditions 1
import BstkHorizontalWall from "./AddNewWallParts/BeforeWorks/StackedRooms/BstkHorizontalWall";
import BstkStackedRoom1 from "./AddNewWallParts/BeforeWorks/StackedRooms/BstkStackedRoom1";
import BstkStackedRoom2 from "./AddNewWallParts/BeforeWorks/StackedRooms/BstkStackedRoom2";
// Condition 2
import BsbsVerticalWall from "./AddNewWallParts/BeforeWorks/SideBySideRooms/BsbsVerticalWall";
import BsbsSideRoom1 from "./AddNewWallParts/BeforeWorks/SideBySideRooms/BsbsSideRoom1";
import BsbsSideRoom2 from "./AddNewWallParts/BeforeWorks/SideBySideRooms/BsbsSideRoom2";
// Condition 3
import AstkHorizontalWall from "./AddNewWallParts/AfterWorks/StackedRooms/AstkHorizontalWall";
import AstkStackedRoom1 from "./AddNewWallParts/AfterWorks/StackedRooms/AstkStackedRoom1";
import AstkStackedRoom2 from "./AddNewWallParts/AfterWorks/StackedRooms/AstkStackedRoom2";
// Condition 2
import AsbsVerticalWall from "./AddNewWallParts/AfterWorks/SideBySideRooms/AsbsVerticalWall";
import AsbsSideRoom1 from "./AddNewWallParts/AfterWorks/SideBySideRooms/AsbsSideRoom1";
import AsbsSideRoom2 from "./AddNewWallParts/AfterWorks/SideBySideRooms/AsbsSideRoom2";

import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  FormGroup,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
  OutlinedInput,
  InputAdornment,
  Switch,
} from "@mui/material";
import { snapshotViewportBox } from "framer-motion";

function EditWall({ siteId, wallId }) {
  const history = useHistory();
  const { user } = useUserProvider();
  const { uid, displayName, email, photoURL } = auth.currentUser || {};
  const { id } = useParams();

  // const initialFieldValues = {
  //   siteStreet: "",
  //   siteNumber: "",
  // };

  const wallRef = firestore.doc(`sites/${siteId}/walls/${wallId}`);

  const [formData, setFormData] = useState({
    registrationPeriod: "",
    roomDisposalDependingBeforeWorks: "",
    roomDisposalDependingAfterWorks: "",
    // Horizontal Wall (After Works)
    horizontalWallOverlay: "",
    horizontalWallOverlayInterventions: "",
    horizontalWallCoating: "",
    horizontalWallCoatingInterventions: "",
    horizontalWallStructure: "",
    horizontalWallStructureInterventions: "",
    horizontalWallCeiling: "",
    horizontalWallCeilingInterventions: "",
    horizontalWallSurface: "",
    horizontalWallNotes: "",
    // Stacked Room 1 (After Works)
    stackedRoom1Name: "",
    stackedRoom1TypeOf: "",
    stackedRoom1Volume: "",
    stackedRoom1LateralWall1: "",
    stackedRoom1LateralWall2: "",
    stackedRoom1LateralWall3: "",
    stackedRoom1LateralWall4: "",
    stackedRoom1Notes: "",
    // Stacked Room 2 (After Works)
    stackedRoom2Name: "",
    stackedRoom2TypeOf: "",
    stackedRoom2Volume: "",
    stackedRoom2LateralWall1: "",
    stackedRoom2LateralWall2: "",
    stackedRoom2LateralWall3: "",
    stackedRoom2LateralWall4: "",
    stackedRoom2Notes: "",
    // Vertical Wall (After Works)
    verticalWallCoatingSideRoom1: "",
    verticalWallCoatingSideRoom1Interventions: "",
    verticalWallStructure: "",
    verticalWallStructureInterventions: "",
    verticalWallCoatingSideRoom2: "",
    verticalWallCoatingSideRoom2Interventions: "",
    verticalWallSurface: "",
    verticalWallNotes: "",
    // Side Room 1 (After Works)
    sideRoom1Name: "",
    sideRoom1TypeOf: "",
    sideRoom1Volume: "",
    sideRoom1LateralWall1: "",
    sideRoom1LateralWall2: "",
    sideRoom1Ceiling: "",
    sideRoom1CeilingStructure: "",
    sideRoom1FloorCoating: "",
    sideRoom1FloorStructure: "",
    sideRoom1Notes: "",
    // Side Room 2 (After Works)
    sideRoom2Name: "",
    sideRoom2TypeOf: "",
    sideRoom2Volume: "",
    sideRoom2LateralWall1: "",
    sideRoom2LateralWall2: "",
    sideRoom2Ceiling: "",
    sideRoom2CeilingStructure: "",
    sideRoom2FloorCoating: "",
    sideRoom2FloorStructure: "",
    sideRoom2Notes: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (2 < 1) {
      toast.error("Please complete the required fields", { theme: "colored" });
      return;
    }
    wallRef.update({
      formData: formData,

      // registrationPeriod: registrationPeriod,
      // roomDisposalDependingBeforeWorks: roomDisposalDependingBeforeWorks,
      // roomDisposalDependingAfterWorks: roomDisposalDependingAfterWorks,
      // // Horizontal Wall (After Works)
      // horizontalWallOverlay: horizontalWallOverlay,
      // horizontalWallOverlayInterventions: horizontalWallOverlayInterventions,
      // horizontalWallCoating: horizontalWallCoating,
      // horizontalWallCoatingInterventions: horizontalWallCoatingInterventions,
      // horizontalWallStructure: horizontalWallStructure,
      // horizontalWallStructureInterventions:
      //   horizontalWallStructureInterventions,
      // horizontalWallCeiling: horizontalWallCeiling,
      // horizontalWallCeilingInterventions: horizontalWallCeilingInterventions,
      // horizontalWallSurface: horizontalWallSurface,
      // horizontalWallNotes: horizontalWallNotes,
      // // Stacked Room 1 (After Works)
      // stackedRoom1Name: stackedRoom1Name,
      // stackedRoom1TypeOf: stackedRoom1TypeOf,
      // stackedRoom1Volume: stackedRoom1Volume,
      // stackedRoom1LateralWall1: stackedRoom1LateralWall1,
      // stackedRoom1LateralWall2: stackedRoom1LateralWall2,
      // stackedRoom1LateralWall3: stackedRoom1LateralWall3,
      // stackedRoom1LateralWall4: stackedRoom1LateralWall4,
      // stackedRoom1Notes: stackedRoom1Notes,
      // // Stacked Room 2 (After Works)
      // stackedRoom2Name: stackedRoom2Name,
      // stackedRoom2TypeOf: stackedRoom2TypeOf,
      // stackedRoom2Volume: stackedRoom2Volume,
      // stackedRoom2LateralWall1: stackedRoom2LateralWall1,
      // stackedRoom2LateralWall2: stackedRoom2LateralWall2,
      // stackedRoom2LateralWall3: stackedRoom2LateralWall3,
      // stackedRoom2LateralWall4: stackedRoom2LateralWall4,
      // stackedRoom2Notes: stackedRoom2Notes,
      // // Vertical Wall (After Works)
      // verticalWallCoatingSideRoom1: verticalWallCoatingSideRoom1,
      // verticalWallCoatingSideRoom1Interventions:
      //   verticalWallCoatingSideRoom1Interventions,
      // verticalWallStructure: verticalWallStructure,
      // verticalWallStructureInterventions: verticalWallStructureInterventions,
      // verticalWallCoatingSideRoom2: verticalWallCoatingSideRoom2,
      // verticalWallCoatingSideRoom2Interventions:
      //   verticalWallCoatingSideRoom2Interventions,
      // verticalWallSurface: verticalWallSurface,
      // verticalWallNotes: verticalWallNotes,
      // // Side Room 1 (After Works)
      // sideRoom1Name: sideRoom1Name,
      // sideRoom1TypeOf: sideRoom1TypeOf,
      // sideRoom1Volume: sideRoom1Volume,
      // sideRoom1LateralWall1: sideRoom1LateralWall1,
      // sideRoom1LateralWall2: sideRoom1LateralWall2,
      // sideRoom1Ceiling: sideRoom1Ceiling,
      // sideRoom1CeilingStructure: sideRoom1CeilingStructure,
      // sideRoom1FloorCoating: sideRoom1FloorCoating,
      // sideRoom1FloorStructure: sideRoom1FloorStructure,
      // sideRoom1Notes: sideRoom1Notes,
      // // Side Room 2 (After Works)
      // sideRoom2Name: sideRoom2Name,
      // sideRoom2TypeOf: sideRoom2TypeOf,
      // sideRoom2Volume: sideRoom2Volume,
      // sideRoom2LateralWall1: sideRoom2LateralWall1,
      // sideRoom2LateralWall2: sideRoom2LateralWall2,
      // sideRoom2Ceiling: sideRoom2Ceiling,
      // sideRoom2CeilingStructure: sideRoom2CeilingStructure,
      // sideRoom2FloorCoating: sideRoom2FloorCoating,
      // sideRoom2FloorStructure: sideRoom2FloorStructure,
      // sideRoom2Notes: sideRoom2Notes,
    });
    history.push(`/sites/${siteId}`);
    toast.success("Wall updated successfully", {
      theme: "colored",
    });
    setFormData("");
  };

  const editHandler = async () => {
    // setMessage("");
    function getWall(wallId) {
      const wallDoc = doc(firestore, "sites", siteId, "walls", wallId);
      return getDoc(wallDoc);
    }
    try {
      const docSnap = await getWall(wallId);
      // console.log("the record is :", docSnap.data());
      setFormData(docSnap.data().formData);
    } catch (err) {
      // setMessage({ error: true, msg: err.message });
      toast.error("Please complete the required fields", { theme: "colored" });
    }
  };

  useEffect(() => {
    // console.log("The id here is : ", id);
    // if (id !== undefined && id !== "") {
    editHandler();
    // }
  }, [id]);

  // siteRef
  //   .update({
  //     // clientCompany: clientCompany,
  //     // clientEmail: clientEmail,
  //     // clientFirstName: clientFirstName,
  //     // clientLastName: clientLastName,
  //     // clientTelephone: clientTelephone,
  //     // entrepreneurCompany: entrepreneurCompany,
  //     // entrepreneurCompanyNumber: entrepreneurCompanyNumber,
  //     // entrepreneurEmail: entrepreneurEmail,
  //     // entrepreneurFirstName: entrepreneurFirstName,
  //     // entrepreneurLastName: entrepreneurLastName,
  //     // entrepreneurTelephone: entrepreneurTelephone,
  //     // siteConstructionYear: siteConstructionYear,
  //     // siteHousingType: siteHousingType,
  //     // siteMunicipality: siteMunicipality,
  //     // siteNotes: siteNotes,
  //     siteNumber: siteNumber,
  //     // sitePostalCode: sitePostalCode,
  //     siteStreet: siteStreet,
  //   })
  //   .then(() => {
  //     history.push("/");
  //     toast.success("Site created successfully", {
  //       theme: "colored",
  //     });
  //   })
  //   .catch((error) => {
  //     toast.error("Please complete the required fields", {
  //       theme: "colored",
  //     });
  //   });
  // setSiteStreet("");
  // setSiteNumber("");
  // // } else {
  // //   history.push("/");
  // // }

  // function fetchUserCreds() {
  //   firebase
  //     .firestore()
  //     .collection("sites")
  //     .doc(id)
  //     .get()
  //     .then((snapshot) => {
  //       siteStreet(snapshot.siteStreet);
  //       setSiteNumber(snapshot.siteNumber);
  //       history.push("/");
  //       toast.success("Site created successfully", {
  //         theme: "colored",
  //       });
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }
  return (
    <form onSubmit={handleSubmit}>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h5">Registration period</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl>
                  {/* <FormLabel id="demo-radio-buttons-group-label">
                    Registration period
                  </FormLabel> */}

                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    name="registration period"
                    value={formData.registrationPeriod}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        registrationPeriod: e.target.value,
                      })
                    }
                  >
                    <FormControlLabel
                      disabled
                      value="Before Works"
                      control={<Radio />}
                      label="Before Works"
                    />
                    <FormControlLabel
                      disabled
                      value="After Works"
                      control={<Radio />}
                      label="After Works"
                    />
                  </RadioGroup>
                </FormControl>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {formData.registrationPeriod === "Before Works"
                  ? "Rooms disposal (Before works)"
                  : "Rooms disposal (After works)"}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl>
                  {/* <FormLabel id="demo-radio-buttons-group-label">
                    Rooms disposal (Before works)
                  </FormLabel> */}
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    //   defaultValue="Before Works"
                    name="radio-buttons-group"
                    value={
                      formData.registrationPeriod === "Before Works"
                        ? formData.roomDisposalDependingBeforeWorks
                        : formData.roomDisposalDependingAfterWorks
                    }
                    onChange={(e) =>
                      formData.registrationPeriod === "Before Works"
                        ? setFormData({
                            ...formData,
                            roomDisposalDependingBeforeWorks: e.target.value,
                          })
                        : setFormData({
                            ...formData,
                            roomDisposalDependingAfterWorks: e.target.value,
                          })
                    }
                  >
                    <FormControlLabel
                      disabled
                      value="Stacked Rooms"
                      control={<Radio />}
                      label="Stacked Rooms"
                    />
                    <FormControlLabel
                      disabled
                      value="Side By Side Rooms"
                      control={<Radio />}
                      label="Side By Side Rooms"
                    />
                  </RadioGroup>
                </FormControl>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <>
        {formData.registrationPeriod === "Before Works" &&
        formData.roomDisposalDependingBeforeWorks === "Stacked Rooms" ? (
          <>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Encoding the horizontal wall (Before works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="horizontalWallOverlay-label">
                          Overlay
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="horizontalWallOverlay-label"
                          label="Overlay"
                          id="horizontalWallOverlay"
                          value={formData.horizontalWallOverlay}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              horizontalWallOverlay: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="pierre-naturelle">
                            pierre naturelle
                          </MenuItem>
                          <MenuItem value="beton-poli">béton poli</MenuItem>
                          <MenuItem value="parquet-lamine">
                            parquet laminé
                          </MenuItem>
                          <MenuItem value="parquet-massif-colle">
                            parquet massif collé
                          </MenuItem>
                          <MenuItem value="parquet-massif-flottant">
                            parquet massif flottant
                          </MenuItem>
                          <MenuItem value="resilient-mince">
                            résilient* mince
                          </MenuItem>
                          <MenuItem value="resilient-multicouches">
                            résilient* multi-couches
                          </MenuItem>
                          <MenuItem value="tapis-mince">tapis mince</MenuItem>
                          <MenuItem value="tapis-multi-couches">
                            tapis multi-couches
                          </MenuItem>
                          <MenuItem value="vynil-liege-caoutchouc">
                            vynil, liège, caoutchouc, ...
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="horizontalWallCoating-label">
                          Coating
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="horizontalWallCoating-label"
                          label="Coating"
                          id="horizontalWallCoating"
                          value={formData.horizontalWallCoating}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              horizontalWallCoating: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="chape de ciment">
                            chape de ciment
                          </MenuItem>
                          <MenuItem value="chape anhydrite">
                            chape anhydrite
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur couche résiliente">
                            Simples plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur bandes résilientes (sans absorbant)">
                            Simples plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur bandes résilientes (avec absorbant)">
                            Simples plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur plots résilients (sans absorbant)">
                            Simples plaques, sur plots résilients (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur plots résilients (avec absorbant)">
                            Simples plaques, sur plots résilients (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur couche résiliente">
                            Multi-plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur bandes résilientes (sans absorbant)">
                            Multi-plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur bandes résilientes (avec absorbant)">
                            Multi-plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur plots résilients (sans absorbant)">
                            Multi-plaques, sur plots résilients (sans absorbant
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur plots résilients (avec absorbant)">
                            Multi-plaques, sur plots résilients (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Solution 'Lewis' avec micro-béton, posée sur structure">
                            Solution 'Lewis' avec micro-béton, posée sur
                            structure
                          </MenuItem>
                          <MenuItem value="Solution 'Lewis' avec micro-béton, sur couche résiliente">
                            Solution 'Lewis' avec micro-béton, sur couche
                            résiliente
                          </MenuItem>
                          <MenuItem value="Solution 'Lewis' avec micro-béton, sur bandes résilientes">
                            Solution 'Lewis' avec micro-béton, sur bandes
                            résilientes
                          </MenuItem>
                          <MenuItem value='Solution "Keep Silence"'>
                            Solution "Keep Silence"
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="horizontalWallStructure-label">
                          Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="horizontalWallStructure-label"
                          label="Structure"
                          id="horizontalWallStructure"
                          value={formData.horizontalWallStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              horizontalWallStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            olives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="horizontalWallCeiling-label">
                          Ceiling
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="horizontalWallCeiling-label"
                          label="Ceiling"
                          id="horizontalWallCeiling"
                          value={formData.horizontalWallCeiling}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              horizontalWallCeiling: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Enduit (plâtre, ciment,...)">
                            Enduit (plâtre, ciment,...)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur ressorts métalliques">
                            Simples plaques, sur ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                            Simples plaques, sur structure métallique
                            indépendante (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur ressorts métalliques">
                            Multi-plaques, sur ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                            Multi-plaques, sur structure métallique indépendante
                            (avec absorbant)
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="horizontalWallSurface"
                          value={formData.horizontalWallSurface}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              horizontalWallSurface: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m2</InputAdornment>
                          }
                          aria-describedby="horizontalWallSurface"
                          inputProps={{
                            "aria-label": "surface",
                          }}
                        />
                      </FormControl>

                      <TextField
                        fullWidth
                        id="HorizontalWallNotes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.horizontalWallNotes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            horizontalWallNotes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Stacked Room 1 (Before works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 1 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.stackedRoom1Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom1Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1TypeOf-label"
                          label="Type of room"
                          id="StackedRoom1TypeOf"
                          value={formData.stackedRoom1TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="StackedRoom1Volume"
                          value={formData.stackedRoom1Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="StackedRoom1Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall1-label"
                          label="Lateral wall 1"
                          id="StackedRoom1LateralWall1"
                          value={formData.stackedRoom1LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall2-label"
                          label="Lateral wall 2"
                          id="StackedRoom1LateralWall2"
                          value={formData.stackedRoom1LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1LateralWall3-label">
                          Lateral wall 3
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall3-label"
                          label="Lateral wall 3"
                          id="StackedRoom1LateralWall3"
                          value={formData.stackedRoom1LateralWall3}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall3: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="lateralWall4-label">
                          Lateral wall 4
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall4-label"
                          label="Lateral wall 4"
                          id="StackedRoom1LateralWall4"
                          value={formData.stackedRoom1LateralWall4}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall4: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="StackedRoom1Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.stackedRoom1Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom1Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Stacked Room 2 (Before works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 1 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.stackedRoom2Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom2Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2TypeOf-label"
                          label="Type of room"
                          id="StackedRoom2TypeOf"
                          value={formData.stackedRoom2TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="StackedRoom2Volume"
                          value={formData.stackedRoom2Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="StackedRoom2Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall1-label"
                          label="Lateral wall 1"
                          id="StackedRoom2LateralWall1"
                          value={formData.stackedRoom2LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall2-label"
                          label="Lateral wall 2"
                          id="StackedRoom2LateralWall2"
                          value={formData.stackedRoom2LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2LateralWall3-label">
                          Lateral wall 3
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall3-label"
                          label="Lateral wall 3"
                          id="StackedRoom2LateralWall3"
                          value={formData.stackedRoom2LateralWall3}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall3: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="lateralWall4-label">
                          Lateral wall 4
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall4-label"
                          label="Lateral wall 4"
                          id="StackedRoom2LateralWall4"
                          value={formData.stackedRoom2LateralWall4}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall4: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="StackedRoom2Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.stackedRoom2Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom2Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        ) : formData.registrationPeriod === "Before Works" &&
          formData.roomDisposalDependingBeforeWorks === "Side By Side Rooms" ? (
          <>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Encoding the vertical wall (Before works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="verticalWallCoatingSideRoom1-label">
                          Coating Side Room 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="verticalWallCoatingSideRoom1-label"
                          label="Coating Side Room 1"
                          id="verticalWallCoatingSideRoom1"
                          value={formData.verticalWallCoatingSideRoom1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              verticalWallCoatingSideRoom1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Enduit"> Enduit </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, fixation rigide">
                            Simple plâques de plâtre, fixation rigide
                          </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, fixation résiliente">
                            Simple plâques de plâtre, fixation résiliente
                          </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, sur structure indépendante (sans absorbant)">
                            Simple plâques de plâtre, sur structure indépendante
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, sur structure indépendante (avec absorbant)">
                            Simple plâques de plâtre, sur structure indépendante
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, fixation rigide">
                            Double plâques de plâtre, fixation rigide
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, fixation résiliente">
                            Double plâques de plâtre, fixation résiliente
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, sur structure indépendante (sans absorbant)">
                            Double plâques de plâtre, sur structure indépendante
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, sur structure indépendante (avec absorbant)">
                            Double plâques de plâtre, sur structure indépendante
                            (avec absorbant)
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel id="verticalWallStructure-label">
                          Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="verticalWallStructure-label"
                          label="Structure"
                          id="verticalWallStructure"
                          value={formData.verticalWallStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              verticalWallStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Ossature bois simple (avec absorbant)">
                            Ossature bois simple (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Ossature bois simple (sans absorbant)">
                            Ossature bois simple (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Ossature bois simple (avec absorbant)">
                            Ossature bois simple (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Ossature bois double (sans absorbant)">
                            Ossature bois double (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Ossature bois double (avec absorbant)">
                            Ossature bois double (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Ossature métallique simple (avec absorbant)">
                            Ossature métallique simple (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Ossature métallique double (avec absorbant)">
                            Ossature métallique double (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Maçonnerie lourde, simple">
                            Maçonnerie lourde, simple
                          </MenuItem>
                          <MenuItem value="Maçonnerie semi-lourde, simple">
                            Maçonnerie semi-lourde, simple
                          </MenuItem>
                          <MenuItem value="Maçonnerie légère, simple">
                            Maçonnerie légère, simple
                          </MenuItem>
                          <MenuItem value="Maçonnerie lourde, double">
                            Maçonnerie lourde, double
                          </MenuItem>
                          <MenuItem value="Maçonnerie semi-lourde, double">
                            Maçonnerie semi-lourde, double
                          </MenuItem>
                          <MenuItem value="Maçonnerie légère, double">
                            Maçonnerie légère, double
                          </MenuItem>
                          <MenuItem value="Maçonnerie (type inconnu), simple">
                            Maçonnerie (type inconnu), simple
                          </MenuItem>
                          <MenuItem value="Maçonnerie (type inconnu), double">
                            Maçonnerie (type inconnu), double
                          </MenuItem>
                          <MenuItem value="Béton préfab, prémurs ? Simple, double">
                            Béton préfab, prémurs ? Simple, double
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel id="verticalWallCoatingSideRoom2-label">
                          Coating Side Room 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="verticalWallCoatingSideRoom2-label"
                          label="Coating Side Room 2"
                          id="verticalWallCoatingSideRoom2"
                          value={formData.verticalWallCoatingSideRoom2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              verticalWallCoatingSideRoom2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Enduit"> Enduit </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, fixation rigide">
                            Simple plâques de plâtre, fixation rigide
                          </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, fixation résiliente">
                            Simple plâques de plâtre, fixation résiliente
                          </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, sur structure indépendante (sans absorbant)">
                            Simple plâques de plâtre, sur structure indépendante
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Simple plâques de plâtre, sur structure indépendante (avec absorbant)">
                            Simple plâques de plâtre, sur structure indépendante
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, fixation rigide">
                            Double plâques de plâtre, fixation rigide
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, fixation résiliente">
                            Double plâques de plâtre, fixation résiliente
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, sur structure indépendante (sans absorbant)">
                            Double plâques de plâtre, sur structure indépendante
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Double plâques de plâtre, sur structure indépendante (avec absorbant)">
                            Double plâques de plâtre, sur structure indépendante
                            (avec absorbant)
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="verticalWallSurface"
                          value={formData.verticalWallSurface}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              verticalWallSurface: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m2</InputAdornment>
                          }
                          aria-describedby="verticalWallSurface"
                          inputProps={{
                            "aria-label": "surface",
                          }}
                        />
                      </FormControl>

                      <TextField
                        fullWidth
                        id="HorizontalWallNotes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.verticalWallNotes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            verticalWallNotes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Side Room 1 (Before works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 1 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.sideRoom1Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom1Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1TypeOf-label"
                          label="Type of room"
                          id="sideRoom1TypeOf"
                          value={formData.sideRoom1TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="sideRoom1Volume"
                          value={formData.sideRoom1Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="sideRoom1Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1LateralWall1-label"
                          label="Lateral wall 1"
                          id="sideRoom1LateralWall1"
                          value={formData.sideRoom1LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1LateralWall2-label"
                          label="Lateral wall 2"
                          id="sideRoom1LateralWall2"
                          value={formData.sideRoom1LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1Ceiling-label">
                          Ceiling
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1Ceiling-label"
                          label="Ceiling"
                          id="sideRoom1Ceiling"
                          value={formData.sideRoom1Ceiling}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1Ceiling: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Enduit (plâtre, ciment,...)">
                            Enduit (plâtre, ciment,...)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur ressorts métalliques">
                            Simples plaques, sur ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                            Simples plaques, sur structure métallique
                            indépendante (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur lattes en bois Multi-plaques, sur ressorts métalliques">
                            Multi-plaques, sur lattes en bois Multi-plaques, sur
                            ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                            Multi-plaques, sur structure métallique indépendante
                            (avec absorbant)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1CeilingStructure-label">
                          Ceiling Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1CeilingStructure-label"
                          label="Ceiling Structure"
                          id="sideRoom1CeilingStructure"
                          value={formData.sideRoom1CeilingStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1CeilingStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1FloorCoating-label">
                          Floor Coating
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1FloorCoating-label"
                          label="Floor Coating"
                          id="sideRoom1FloorCoating"
                          value={formData.sideRoom1FloorCoating}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1FloorCoating: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="chape de ciment">
                            chape de ciment
                          </MenuItem>
                          <MenuItem value="chape anhydrite">
                            chape anhydrite
                          </MenuItem>
                          <MenuItem value="simples plaques, sur couche résiliente">
                            simples plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (sans absorbant)">
                            simples plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (avec absorbant)">
                            simples plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (sans absorbant)">
                            simples plaques, sur plots résilients (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (avec absorbant)">
                            simples plaques, sur plots résilients (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur couche résiliente">
                            multi-plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (sans absorbant)">
                            multi-plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (avec absorbant)">
                            multi-plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (sans absorbant)">
                            multi-plaques, sur plots résilients (sans absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (avec absorbant)">
                            multi-plaques, sur plots résilients (avec absorbant)
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, posée sur structure'>
                            solution "Lewis" avec micro-béton, posée sur
                            structure
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur couche résiliente'>
                            solution "Lewis" avec micro-béton, sur couche
                            résiliente
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur bandes résilientes'>
                            solution "Lewis" avec micro-béton, sur bandes
                            résilientes
                          </MenuItem>
                          <MenuItem value='solution "Keep Silence"'>
                            solution "Keep Silence"
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1FloorStructure-label">
                          Floor Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1FloorStructure-label"
                          label="Floor Structure"
                          id="sideRoom1FloorStructure"
                          value={formData.sideRoom1FloorStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1FloorStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="sideRoom1Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.sideRoom1Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom1Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Side Room 2 (Before works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 2 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.sideRoom2Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom2Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2TypeOf-label"
                          label="Type of room"
                          id="sideRoom2TypeOf"
                          value={formData.sideRoom2TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="sideRoom2Volume"
                          value={formData.sideRoom2Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="sideRoom2Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2LateralWall1-label"
                          label="Lateral wall 1"
                          id="sideRoom2LateralWall1"
                          value={formData.sideRoom2LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2LateralWall2-label"
                          label="Lateral wall 2"
                          id="sideRoom2LateralWall2"
                          value={formData.sideRoom2LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2Ceiling-label">
                          Ceiling
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2Ceiling-label"
                          label="Ceiling"
                          id="sideRoom2Ceiling"
                          value={formData.sideRoom2Ceiling}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2Ceiling: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Enduit (plâtre, ciment,...)">
                            Enduit (plâtre, ciment,...)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur ressorts métalliques">
                            Simples plaques, sur ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                            Simples plaques, sur structure métallique
                            indépendante (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur lattes en bois Multi-plaques, sur ressorts métalliques">
                            Multi-plaques, sur lattes en bois Multi-plaques, sur
                            ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                            Multi-plaques, sur structure métallique indépendante
                            (avec absorbant)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2CeilingStructure-label">
                          Ceiling Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2CeilingStructure-label"
                          label="Ceiling Structure"
                          id="sideRoom2CeilingStructure"
                          value={formData.sideRoom2CeilingStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2CeilingStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2FloorCoating-label">
                          Floor Coating
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2FloorCoating-label"
                          label="Floor Coating"
                          id="sideRoom2FloorCoating"
                          value={formData.sideRoom2FloorCoating}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2FloorCoating: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="chape de ciment">
                            chape de ciment
                          </MenuItem>
                          <MenuItem value="chape anhydrite">
                            chape anhydrite
                          </MenuItem>
                          <MenuItem value="simples plaques, sur couche résiliente">
                            simples plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (sans absorbant)">
                            simples plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (avec absorbant)">
                            simples plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (sans absorbant)">
                            simples plaques, sur plots résilients (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (avec absorbant)">
                            simples plaques, sur plots résilients (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur couche résiliente">
                            multi-plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (sans absorbant)">
                            multi-plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (avec absorbant)">
                            multi-plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (sans absorbant)">
                            multi-plaques, sur plots résilients (sans absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (avec absorbant)">
                            multi-plaques, sur plots résilients (avec absorbant)
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, posée sur structure'>
                            solution "Lewis" avec micro-béton, posée sur
                            structure
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur couche résiliente'>
                            solution "Lewis" avec micro-béton, sur couche
                            résiliente
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur bandes résilientes'>
                            solution "Lewis" avec micro-béton, sur bandes
                            résilientes
                          </MenuItem>
                          <MenuItem value='solution "Keep Silence"'>
                            solution "Keep Silence"
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2FloorStructure-label">
                          Floor Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2FloorStructure-label"
                          label="Floor Structure"
                          id="sideRoom2FloorStructure"
                          value={formData.sideRoom2FloorStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2FloorStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="sideRoom2Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.sideRoom2Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom2Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        ) : formData.registrationPeriod === "After Works" &&
          formData.roomDisposalDependingAfterWorks === "Stacked Rooms" ? (
          <>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Encoding the horizontal wall (After works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormGroup className="fieldset_and_switch">
                        <FormControl fullWidth>
                          <InputLabel id="horizontalWallOverlay-label">
                            Overlay
                          </InputLabel>
                          <Select
                            fullWidth
                            // error={siteHousingTypeError}
                            labelId="horizontalWallOverlay-label"
                            label="Overlay"
                            id="horizontalWallOverlay"
                            value={formData.horizontalWallOverlay}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                horizontalWallOverlay: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="pierre-naturelle">
                              pierre naturelle
                            </MenuItem>
                            <MenuItem value="beton-poli">béton poli</MenuItem>
                            <MenuItem value="parquet-lamine">
                              parquet laminé
                            </MenuItem>
                            <MenuItem value="parquet-massif-colle">
                              parquet massif collé
                            </MenuItem>
                            <MenuItem value="parquet-massif-flottant">
                              parquet massif flottant
                            </MenuItem>
                            <MenuItem value="resilient-mince">
                              résilient* mince
                            </MenuItem>
                            <MenuItem value="resilient-multicouches">
                              résilient* multi-couches
                            </MenuItem>
                            <MenuItem value="tapis-mince">tapis mince</MenuItem>
                            <MenuItem value="tapis-multi-couches">
                              tapis multi-couches
                            </MenuItem>
                            <MenuItem value="vynil-liege-caoutchouc">
                              vynil, liège, caoutchouc, ...
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          sx={{ ml: 0, mt: 1 }}
                          label={
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                            >
                              Interventions Already Performed
                            </Typography>
                          }
                          control={
                            <Switch
                              // defaultChecked
                              size="small"
                              // checked={horizontalWallOverlayInterventions}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  horizontalWallOverlayInterventions:
                                    e.target.value,
                                })
                              }
                              // value="lol"
                            />
                          }
                        />
                      </FormGroup>

                      <FormGroup className="fieldset_and_switch">
                        <FormControl fullWidth>
                          <InputLabel id="horizontalWallCoating-label">
                            Coating
                          </InputLabel>
                          <Select
                            fullWidth
                            // error={siteHousingTypeError}
                            labelId="horizontalWallCoating-label"
                            label="Coating"
                            id="horizontalWallCoating"
                            value={formData.horizontalWallCoating}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                horizontalWallCoating: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="chape de ciment">
                              chape de ciment
                            </MenuItem>
                            <MenuItem value="chape anhydrite">
                              chape anhydrite
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur couche résiliente">
                              Simples plaques, sur couche résiliente
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur bandes résilientes (sans absorbant)">
                              Simples plaques, sur bandes résilientes (sans
                              absorbant)
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur bandes résilientes (avec absorbant)">
                              Simples plaques, sur bandes résilientes (avec
                              absorbant)
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur plots résilients (sans absorbant)">
                              Simples plaques, sur plots résilients (sans
                              absorbant)
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur plots résilients (avec absorbant)">
                              Simples plaques, sur plots résilients (avec
                              absorbant)
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur couche résiliente">
                              Multi-plaques, sur couche résiliente
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur bandes résilientes (sans absorbant)">
                              Multi-plaques, sur bandes résilientes (sans
                              absorbant)
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur bandes résilientes (avec absorbant)">
                              Multi-plaques, sur bandes résilientes (avec
                              absorbant)
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur plots résilients (sans absorbant)">
                              Multi-plaques, sur plots résilients (sans
                              absorbant
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur plots résilients (avec absorbant)">
                              Multi-plaques, sur plots résilients (avec
                              absorbant)
                            </MenuItem>
                            <MenuItem value="Solution 'Lewis' avec micro-béton, posée sur structure">
                              Solution 'Lewis' avec micro-béton, posée sur
                              structure
                            </MenuItem>
                            <MenuItem value="Solution 'Lewis' avec micro-béton, sur couche résiliente">
                              Solution 'Lewis' avec micro-béton, sur couche
                              résiliente
                            </MenuItem>
                            <MenuItem value="Solution 'Lewis' avec micro-béton, sur bandes résilientes">
                              Solution 'Lewis' avec micro-béton, sur bandes
                              résilientes
                            </MenuItem>
                            <MenuItem value='Solution "Keep Silence"'>
                              Solution "Keep Silence"
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          sx={{ ml: 0, mt: 1 }}
                          label={
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                            >
                              Interventions Already Performed
                            </Typography>
                          }
                          control={
                            <Switch
                              // defaultChecked
                              size="small"
                              // checked={horizontalWallCoatingInterventions}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  horizontalWallCoatingInterventions:
                                    e.target.value,
                                })
                              }
                              // value="lol"
                            />
                          }
                        />
                      </FormGroup>

                      <FormGroup className="fieldset_and_switch">
                        <FormControl fullWidth>
                          <InputLabel id="horizontalWallStructure-label">
                            Structure
                          </InputLabel>
                          <Select
                            fullWidth
                            // error={siteHousingTypeError}
                            labelId="horizontalWallStructure-label"
                            label="Structure"
                            id="horizontalWallStructure"
                            value={formData.horizontalWallStructure}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                horizontalWallStructure: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="prédalles + couche de compression">
                              prédalles + couche de compression
                            </MenuItem>
                            <MenuItem value="hourdis béton + couche de compression">
                              hourdis béton + couche de compression
                            </MenuItem>
                            <MenuItem value="poutrains-claveaux + couche de compression">
                              poutrains-claveaux + couche de compression
                            </MenuItem>
                            <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                              olives en bois, sans plaques de sol et de plafond
                              (sans absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                              solives en bois, sans plaques de sol et de plafond
                              (avec absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                              solives en bois, sans plaques de sol, avec plaques
                              de plafond (sans absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                              solives en bois, sans plaques de sol, avec plaques
                              de plafond (avec absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                              solives en bois, avec simples plaques de sol, sans
                              plaques de plafond (sans absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                              solives en bois, avec simples plaques de sol, sans
                              plaques de plafond (avec absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                              solives en bois, avec multi-plaques de sol, sans
                              plaques de plafond (sans absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                              solives en bois, avec multi-plaques de sol, sans
                              plaques de plafond (avec absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                              solives en bois, avec simples plaques de sol, avec
                              plaques de plafond (sans absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                              solives en bois, avec simples plaques de sol, avec
                              plaques de plafond (avec absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                              solives en bois, avec multi-plaques de sol, avec
                              plaques de plafond (sans absorbant)
                            </MenuItem>
                            <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                              solives en bois, avec multi-plaques de sol, avec
                              plaques de plafond (avec absorbant)
                            </MenuItem>
                            <MenuItem value="autre (semi-lourd)">
                              autre (semi-lourd)
                            </MenuItem>
                            <MenuItem value="autre (léger)">
                              autre (léger)
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          sx={{ ml: 0, mt: 1 }}
                          label={
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                            >
                              Interventions Already Performed
                            </Typography>
                          }
                          control={
                            <Switch
                              // defaultChecked
                              size="small"
                              // checked={horizontalWallStructureInterventions}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  horizontalWallStructureInterventions:
                                    e.target.value,
                                })
                              }
                              // value="lol"
                            />
                          }
                        />
                      </FormGroup>

                      <FormGroup className="fieldset_and_switch">
                        <FormControl fullWidth>
                          <InputLabel id="horizontalWallCeiling-label">
                            Ceiling
                          </InputLabel>
                          <Select
                            fullWidth
                            // error={siteHousingTypeError}
                            labelId="horizontalWallCeiling-label"
                            label="Ceiling"
                            id="horizontalWallCeiling"
                            value={formData.horizontalWallCeiling}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                horizontalWallCeiling: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="Enduit (plâtre, ciment,...)">
                              Enduit (plâtre, ciment,...)
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur ressorts métalliques">
                              Simples plaques, sur ressorts métalliques
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                              Simples plaques, sur structure métallique
                              suspendue (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                              Simples plaques, sur structure métallique
                              suspendue (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                              Simples plaques, sur structure métallique
                              indépendante (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur ressorts métalliques">
                              Multi-plaques, sur ressorts métalliques
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                              Multi-plaques, sur structure métallique suspendue
                              (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                              Multi-plaques, sur structure métallique suspendue
                              (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                              Multi-plaques, sur structure métallique
                              indépendante (avec absorbant)
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          sx={{ ml: 0, mt: 1 }}
                          label={
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                            >
                              Interventions Already Performed
                            </Typography>
                          }
                          control={
                            <Switch
                              // defaultChecked
                              size="small"
                              // checked={horizontalWallOverlayInterventions}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  horizontalWallCeilingInterventions:
                                    e.target.value,
                                })
                              }
                              // value="lol"
                            />
                          }
                        />
                      </FormGroup>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="horizontalWallSurface"
                          value={formData.horizontalWallSurface}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              horizontalWallSurface: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m2</InputAdornment>
                          }
                          aria-describedby="horizontalWallSurface"
                          inputProps={{
                            "aria-label": "surface",
                          }}
                        />
                      </FormControl>

                      <TextField
                        fullWidth
                        id="HorizontalWallNotes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.horizontalWallNotes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            horizontalWallNotes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Stacked Room 1 (After works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 1 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.stackedRoom1Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom1Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1TypeOf-label"
                          label="Type of room"
                          id="StackedRoom1TypeOf"
                          value={formData.stackedRoom1TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="StackedRoom1Volume"
                          value={formData.stackedRoom1Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="StackedRoom1Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall1-label"
                          label="Lateral wall 1"
                          id="StackedRoom1LateralWall1"
                          value={formData.stackedRoom1LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall2-label"
                          label="Lateral wall 2"
                          id="StackedRoom1LateralWall2"
                          value={formData.stackedRoom1LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom1LateralWall3-label">
                          Lateral wall 3
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall3-label"
                          label="Lateral wall 3"
                          id="StackedRoom1LateralWall3"
                          value={formData.stackedRoom1LateralWall3}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall3: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="lateralWall4-label">
                          Lateral wall 4
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom1LateralWall4-label"
                          label="Lateral wall 4"
                          id="StackedRoom1LateralWall4"
                          value={formData.stackedRoom1LateralWall4}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom1LateralWall4: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="StackedRoom1Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.stackedRoom1Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom1Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Stacked Room 2 (After works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 1 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.stackedRoom2Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom2Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2TypeOf-label"
                          label="Type of room"
                          id="StackedRoom2TypeOf"
                          value={formData.stackedRoom2TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="StackedRoom2Volume"
                          value={formData.stackedRoom2Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="StackedRoom2Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall1-label"
                          label="Lateral wall 1"
                          id="StackedRoom2LateralWall1"
                          value={formData.stackedRoom2LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall2-label"
                          label="Lateral wall 2"
                          id="StackedRoom2LateralWall2"
                          value={formData.stackedRoom2LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="StackedRoom2LateralWall3-label">
                          Lateral wall 3
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall3-label"
                          label="Lateral wall 3"
                          id="StackedRoom2LateralWall3"
                          value={formData.stackedRoom2LateralWall3}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall3: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="lateralWall4-label">
                          Lateral wall 4
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="StackedRoom2LateralWall4-label"
                          label="Lateral wall 4"
                          id="StackedRoom2LateralWall4"
                          value={formData.stackedRoom2LateralWall4}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              stackedRoom2LateralWall4: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="StackedRoom2Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.stackedRoom2Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            stackedRoom2Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        ) : formData.registrationPeriod === "After Works" &&
          formData.roomDisposalDependingAfterWorks === "Side By Side Rooms" ? (
          <>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Encoding the vertical wall (After works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormGroup>
                        <FormControl fullWidth>
                          <InputLabel id="verticalWallCoatingSideRoom1-label">
                            Coating Side Room 1
                          </InputLabel>
                          <Select
                            fullWidth
                            // error={siteHousingTypeError}
                            labelId="verticalWallCoatingSideRoom1-label"
                            label="Coating Side Room 1"
                            id="verticalWallCoatingSideRoom1"
                            value={formData.verticalWallCoatingSideRoom1}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                verticalWallCoatingSideRoom1: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="Enduit"> Enduit </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, fixation rigide">
                              Simple plâques de plâtre, fixation rigide
                            </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, fixation résiliente">
                              Simple plâques de plâtre, fixation résiliente
                            </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, sur structure indépendante (sans absorbant)">
                              Simple plâques de plâtre, sur structure
                              indépendante (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, sur structure indépendante (avec absorbant)">
                              Simple plâques de plâtre, sur structure
                              indépendante (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, fixation rigide">
                              Double plâques de plâtre, fixation rigide
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, fixation résiliente">
                              Double plâques de plâtre, fixation résiliente
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, sur structure indépendante (sans absorbant)">
                              Double plâques de plâtre, sur structure
                              indépendante (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, sur structure indépendante (avec absorbant)">
                              Double plâques de plâtre, sur structure
                              indépendante (avec absorbant)
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          sx={{ ml: 0, mt: 1 }}
                          label={
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                            >
                              Interventions Already Performed
                            </Typography>
                          }
                          control={
                            <Switch
                              // defaultChecked
                              size="small"
                              // checked={verticalWallCoatingSideRoom1Interventions}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  verticalWallCoatingSideRoom1Interventions:
                                    e.target.value,
                                })
                              }
                              // value="lol"
                            />
                          }
                        />
                      </FormGroup>

                      <FormGroup>
                        <FormControl fullWidth>
                          <InputLabel id="verticalWallStructure-label">
                            Structure
                          </InputLabel>
                          <Select
                            fullWidth
                            // error={siteHousingTypeError}
                            labelId="verticalWallStructure-label"
                            label="Structure"
                            id="verticalWallStructure"
                            value={formData.verticalWallStructure}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                verticalWallStructure: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="Ossature bois simple (avec absorbant)">
                              Ossature bois simple (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Ossature bois simple (sans absorbant)">
                              Ossature bois simple (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Ossature bois simple (avec absorbant)">
                              Ossature bois simple (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Ossature bois double (sans absorbant)">
                              Ossature bois double (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Ossature bois double (avec absorbant)">
                              Ossature bois double (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Ossature métallique simple (avec absorbant)">
                              Ossature métallique simple (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Ossature métallique double (avec absorbant)">
                              Ossature métallique double (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Maçonnerie lourde, simple">
                              Maçonnerie lourde, simple
                            </MenuItem>
                            <MenuItem value="Maçonnerie semi-lourde, simple">
                              Maçonnerie semi-lourde, simple
                            </MenuItem>
                            <MenuItem value="Maçonnerie légère, simple">
                              Maçonnerie légère, simple
                            </MenuItem>
                            <MenuItem value="Maçonnerie lourde, double">
                              Maçonnerie lourde, double
                            </MenuItem>
                            <MenuItem value="Maçonnerie semi-lourde, double">
                              Maçonnerie semi-lourde, double
                            </MenuItem>
                            <MenuItem value="Maçonnerie légère, double">
                              Maçonnerie légère, double
                            </MenuItem>
                            <MenuItem value="Maçonnerie (type inconnu), simple">
                              Maçonnerie (type inconnu), simple
                            </MenuItem>
                            <MenuItem value="Maçonnerie (type inconnu), double">
                              Maçonnerie (type inconnu), double
                            </MenuItem>
                            <MenuItem value="Béton préfab, prémurs ? Simple, double">
                              Béton préfab, prémurs ? Simple, double
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          sx={{ ml: 0, mt: 1 }}
                          label={
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                            >
                              Interventions Already Performed
                            </Typography>
                          }
                          control={
                            <Switch
                              // defaultChecked
                              size="small"
                              // checked={verticalWallStructureInterventions}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  verticalWallStructureInterventions:
                                    e.target.value,
                                })
                              }
                              // value="lol"
                            />
                          }
                        />
                      </FormGroup>

                      <FormGroup>
                        <FormControl fullWidth>
                          <InputLabel id="verticalWallCoatingSideRoom2-label">
                            Coating Side Room 2
                          </InputLabel>
                          <Select
                            fullWidth
                            // error={siteHousingTypeError}
                            labelId="verticalWallCoatingSideRoom2-label"
                            label="Coating Side Room 2"
                            id="verticalWallCoatingSideRoom2"
                            value={formData.verticalWallCoatingSideRoom2}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                verticalWallCoatingSideRoom2: e.target.value,
                              })
                            }
                          >
                            <MenuItem value="Enduit"> Enduit </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, fixation rigide">
                              Simple plâques de plâtre, fixation rigide
                            </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, fixation résiliente">
                              Simple plâques de plâtre, fixation résiliente
                            </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, sur structure indépendante (sans absorbant)">
                              Simple plâques de plâtre, sur structure
                              indépendante (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Simple plâques de plâtre, sur structure indépendante (avec absorbant)">
                              Simple plâques de plâtre, sur structure
                              indépendante (avec absorbant)
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, fixation rigide">
                              Double plâques de plâtre, fixation rigide
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, fixation résiliente">
                              Double plâques de plâtre, fixation résiliente
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, sur structure indépendante (sans absorbant)">
                              Double plâques de plâtre, sur structure
                              indépendante (sans absorbant)
                            </MenuItem>
                            <MenuItem value="Double plâques de plâtre, sur structure indépendante (avec absorbant)">
                              Double plâques de plâtre, sur structure
                              indépendante (avec absorbant)
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControlLabel
                          sx={{ ml: 0, mt: 1 }}
                          label={
                            <Typography
                              color="textSecondary"
                              variant="subtitle2"
                            >
                              Interventions Already Performed
                            </Typography>
                          }
                          control={
                            <Switch
                              // defaultChecked
                              size="small"
                              // checked={verticalWallCoatingSideRoom2Interventions}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  verticalWallCoatingSideRoom2Interventions:
                                    e.target.value,
                                })
                              }
                              // value="lol"
                            />
                          }
                        />
                      </FormGroup>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="verticalWallSurface"
                          value={formData.verticalWallSurface}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              verticalWallSurface: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m2</InputAdornment>
                          }
                          aria-describedby="verticalWallSurface"
                          inputProps={{
                            "aria-label": "surface",
                          }}
                        />
                      </FormControl>

                      <TextField
                        fullWidth
                        id="HorizontalWallNotes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.verticalWallNotes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            verticalWallNotes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Side Room 1 (After works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 1 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.sideRoom1Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom1Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1TypeOf-label"
                          label="Type of room"
                          id="sideRoom1TypeOf"
                          value={formData.sideRoom1TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="sideRoom1Volume"
                          value={formData.sideRoom1Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="sideRoom1Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1LateralWall1-label"
                          label="Lateral wall 1"
                          id="sideRoom1LateralWall1"
                          value={formData.sideRoom1LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1LateralWall2-label"
                          label="Lateral wall 2"
                          id="sideRoom1LateralWall2"
                          value={formData.sideRoom1LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1Ceiling-label">
                          Ceiling
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1Ceiling-label"
                          label="Ceiling"
                          id="sideRoom1Ceiling"
                          value={formData.sideRoom1Ceiling}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1Ceiling: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Enduit (plâtre, ciment,...)">
                            Enduit (plâtre, ciment,...)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur ressorts métalliques">
                            Simples plaques, sur ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                            Simples plaques, sur structure métallique
                            indépendante (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur lattes en bois Multi-plaques, sur ressorts métalliques">
                            Multi-plaques, sur lattes en bois Multi-plaques, sur
                            ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                            Multi-plaques, sur structure métallique indépendante
                            (avec absorbant)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1CeilingStructure-label">
                          Ceiling Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1CeilingStructure-label"
                          label="Ceiling Structure"
                          id="sideRoom1CeilingStructure"
                          value={formData.sideRoom1CeilingStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1CeilingStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1FloorCoating-label">
                          Floor Coating
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1FloorCoating-label"
                          label="Floor Coating"
                          id="sideRoom1FloorCoating"
                          value={formData.sideRoom1FloorCoating}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1FloorCoating: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="chape de ciment">
                            chape de ciment
                          </MenuItem>
                          <MenuItem value="chape anhydrite">
                            chape anhydrite
                          </MenuItem>
                          <MenuItem value="simples plaques, sur couche résiliente">
                            simples plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (sans absorbant)">
                            simples plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (avec absorbant)">
                            simples plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (sans absorbant)">
                            simples plaques, sur plots résilients (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (avec absorbant)">
                            simples plaques, sur plots résilients (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur couche résiliente">
                            multi-plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (sans absorbant)">
                            multi-plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (avec absorbant)">
                            multi-plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (sans absorbant)">
                            multi-plaques, sur plots résilients (sans absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (avec absorbant)">
                            multi-plaques, sur plots résilients (avec absorbant)
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, posée sur structure'>
                            solution "Lewis" avec micro-béton, posée sur
                            structure
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur couche résiliente'>
                            solution "Lewis" avec micro-béton, sur couche
                            résiliente
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur bandes résilientes'>
                            solution "Lewis" avec micro-béton, sur bandes
                            résilientes
                          </MenuItem>
                          <MenuItem value='solution "Keep Silence"'>
                            solution "Keep Silence"
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom1FloorStructure-label">
                          Floor Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom1FloorStructure-label"
                          label="Floor Structure"
                          id="sideRoom1FloorStructure"
                          value={formData.sideRoom1FloorStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom1FloorStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="sideRoom1Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.sideRoom1Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom1Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Card sx={{ marginBottom: "30px" }}>
              <CardContent>
                <Grid container spacing={4}>
                  <Grid item xs={12}>
                    <Typography variant="h5">
                      Side Room 2 (After works)
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <TextField
                        fullWidth
                        type="text"
                        name="Room 2 Name"
                        label="Room's Name"
                        // placeholder="Room's Name"
                        value={formData.sideRoom2Name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom2Name: e.target.value,
                          })
                        }
                      />
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2TypeOf-label">
                          Type of room
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2TypeOf-label"
                          label="Type of room"
                          id="sideRoom2TypeOf"
                          value={formData.sideRoom2TypeOf}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2TypeOf: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="bedroom">bedroom</MenuItem>
                          <MenuItem value="bathroom">bathroom</MenuItem>
                          <MenuItem value="livingroom">livingroom</MenuItem>
                          <MenuItem value="kitchen">kitchen</MenuItem>
                          <MenuItem value="office">office</MenuItem>
                          <MenuItem value="corridor">corridor</MenuItem>
                          <MenuItem value="basement">basement</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl sx={{}} variant="outlined">
                        <OutlinedInput
                          id="sideRoom2Volume"
                          value={formData.sideRoom2Volume}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2Volume: e.target.value,
                            })
                          }
                          endAdornment={
                            <InputAdornment position="end">m3</InputAdornment>
                          }
                          aria-describedby="sideRoom2Volume"
                          inputProps={{
                            "aria-label": "Volume",
                          }}
                        />
                      </FormControl>
                    </Stack>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Stack spacing={2}>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2LateralWall1-label">
                          Lateral wall 1
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2LateralWall1-label"
                          label="Lateral wall 1"
                          id="sideRoom2LateralWall1"
                          value={formData.sideRoom2LateralWall1}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2LateralWall1: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2LateralWall2-label">
                          Lateral wall 2
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2LateralWall2-label"
                          label="Lateral wall 2"
                          id="sideRoom2LateralWall2"
                          value={formData.sideRoom2LateralWall2}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2LateralWall2: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="mur massif 10cm">
                            mur massif 10cm
                          </MenuItem>
                          <MenuItem value="mur massif 20cm">
                            mur massif 20cm
                          </MenuItem>
                          <MenuItem value="mur massif 30cm">
                            mur massif 30cm
                          </MenuItem>
                          <MenuItem value="mur massif 40cm">
                            mur massif 40cm
                          </MenuItem>
                          <MenuItem value="mur massif 10cm + doublage acoustique">
                            mur massif 10cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 20cm + doublage acoustique">
                            mur massif 20cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 30cm + doublage acoustique">
                            mur massif 30cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="mur massif 40cm + doublage acoustique">
                            mur massif 40cm + doublage acoustique
                          </MenuItem>
                          <MenuItem value="cloison légère">
                            cloison légère
                          </MenuItem>
                          <MenuItem value="cloison légère + doublage acoustique">
                            cloison légère + doublage acoustique
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2Ceiling-label">
                          Ceiling
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2Ceiling-label"
                          label="Ceiling"
                          id="sideRoom2Ceiling"
                          value={formData.sideRoom2Ceiling}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2Ceiling: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="Enduit (plâtre, ciment,...)">
                            Enduit (plâtre, ciment,...)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur ressorts métalliques">
                            Simples plaques, sur ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                            Simples plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                            Simples plaques, sur structure métallique
                            indépendante (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur lattes en bois Multi-plaques, sur ressorts métalliques">
                            Multi-plaques, sur lattes en bois Multi-plaques, sur
                            ressorts métalliques
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                            Multi-plaques, sur structure métallique suspendue
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                            Multi-plaques, sur structure métallique indépendante
                            (avec absorbant)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2CeilingStructure-label">
                          Ceiling Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2CeilingStructure-label"
                          label="Ceiling Structure"
                          id="sideRoom2CeilingStructure"
                          value={formData.sideRoom2CeilingStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2CeilingStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2FloorCoating-label">
                          Floor Coating
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2FloorCoating-label"
                          label="Floor Coating"
                          id="sideRoom2FloorCoating"
                          value={formData.sideRoom2FloorCoating}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2FloorCoating: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="chape de ciment">
                            chape de ciment
                          </MenuItem>
                          <MenuItem value="chape anhydrite">
                            chape anhydrite
                          </MenuItem>
                          <MenuItem value="simples plaques, sur couche résiliente">
                            simples plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (sans absorbant)">
                            simples plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur bandes résilientes (avec absorbant)">
                            simples plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (sans absorbant)">
                            simples plaques, sur plots résilients (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="simples plaques, sur plots résilients (avec absorbant)">
                            simples plaques, sur plots résilients (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur couche résiliente">
                            multi-plaques, sur couche résiliente
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (sans absorbant)">
                            multi-plaques, sur bandes résilientes (sans
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur bandes résilientes (avec absorbant)">
                            multi-plaques, sur bandes résilientes (avec
                            absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (sans absorbant)">
                            multi-plaques, sur plots résilients (sans absorbant)
                          </MenuItem>
                          <MenuItem value="multi-plaques, sur plots résilients (avec absorbant)">
                            multi-plaques, sur plots résilients (avec absorbant)
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, posée sur structure'>
                            solution "Lewis" avec micro-béton, posée sur
                            structure
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur couche résiliente'>
                            solution "Lewis" avec micro-béton, sur couche
                            résiliente
                          </MenuItem>
                          <MenuItem value='solution "Lewis" avec micro-béton, sur bandes résilientes'>
                            solution "Lewis" avec micro-béton, sur bandes
                            résilientes
                          </MenuItem>
                          <MenuItem value='solution "Keep Silence"'>
                            solution "Keep Silence"
                          </MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl fullWidth>
                        <InputLabel id="sideRoom2FloorStructure-label">
                          Floor Structure
                        </InputLabel>
                        <Select
                          fullWidth
                          // error={siteHousingTypeError}
                          labelId="sideRoom2FloorStructure-label"
                          label="Floor Structure"
                          id="sideRoom2FloorStructure"
                          value={formData.sideRoom2FloorStructure}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              sideRoom2FloorStructure: e.target.value,
                            })
                          }
                        >
                          <MenuItem value="prédalles + couche de compression">
                            prédalles + couche de compression
                          </MenuItem>
                          <MenuItem value="hourdis béton + couche de compression">
                            hourdis béton + couche de compression
                          </MenuItem>
                          <MenuItem value="poutrains-claveaux + couche de compression">
                            poutrains-claveaux + couche de compression
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol et de plafond
                            (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, sans plaques de sol, avec plaques
                            de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, sans
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec simples plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (sans absorbant)
                          </MenuItem>
                          <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                            solives en bois, avec multi-plaques de sol, avec
                            plaques de plafond (avec absorbant)
                          </MenuItem>
                          <MenuItem value="autre (lourd)">
                            autre (lourd)
                          </MenuItem>
                          <MenuItem value="autre (semi-lourd)">
                            autre (semi-lourd)
                          </MenuItem>
                          <MenuItem value="autre (léger)">
                            autre (léger)
                          </MenuItem>
                        </Select>
                      </FormControl>

                      <TextField
                        fullWidth
                        id="sideRoom2Notes"
                        label="Additional Notes"
                        multiline
                        rows={4}
                        value={formData.sideRoom2Notes}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            sideRoom2Notes: e.target.value,
                          })
                        }
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </>
        ) : (
          "error"
        )}
      </>
      <Grid align="right">
        <Button
          variant="contained"
          size="large"
          type="submit"
          // onClick={() => changeCreds()}
          // value={id ? "Update" : "Save"}
        >
          Save changes
        </Button>
        {/* <Button
          variant="contained"
          title="Fetch data"
          type="submit"
          onClick={() => fetchUserCreds()}
        >
          Hein ?
        </Button> */}
      </Grid>
    </form>
  );
}
export default EditWall;
